import { AppThunkDispatch } from '@Reducers/index';

import { CompanySettingsApi, ICompanySettings } from '@ClientApi/companySettings';

export const STORE_COMPANY_SETTINGS = 'STORE_COMPANY_SETTINGS';

export class StoreCompanySettings {
  readonly type = STORE_COMPANY_SETTINGS;

  constructor(public settings: ICompanySettings | null) {}
}

export type CompanySettingsAction = StoreCompanySettings;

export const fetchCompanySettings = (companyId: string) => async (dispatch: AppThunkDispatch) => {
  try {
    const settings = await CompanySettingsApi.get(companyId);
    dispatch(new StoreCompanySettings(settings));
  } catch {
    dispatch(new StoreCompanySettings(null));
  }
};
